export default "__VITE_ASSET__Dck8cBT___"